export class ThemeEmbeddedManager {
    async init() { }
    async onChangeTheme() {
        throw new Error('ThemeEmbeddedManager not support onChangeTheme');
    }
    async onChangeMainColor() {
        throw new Error('ThemeEmbeddedManager not support onChangeMainColor');
    }
    async onChangeBrandColor() {
        throw new Error('ThemeEmbeddedManager not support onChangeBrandColor');
    }
    getActiveBrandColor() {
        throw new Error('ThemeEmbeddedManager not support getActiveBrandColor');
    }
    getActiveMainColor() {
        throw new Error('ThemeEmbeddedManager not support getActiveMainColor');
    }
}
//# sourceMappingURL=theme-embedded-controller.js.map